import PosthogService from '~/services/posthog/PosthogService';

// Event-specific interface (co-located)
export interface IInterviewRequestAddInterviewsClickedPayload {
  postingId: string;
}

/**
 * Fires when user clicks "Add Interviews" on the interview request page
 * Event: dental_portal:interview_request:add_interviews_clicked
 */
export function fireInterviewRequestAddInterviewsClicked(
  payload: IInterviewRequestAddInterviewsClickedPayload,
): void {
  PosthogService.getInstance().track('dental_portal:interview_request:add_interviews_clicked', {
    posting_id: payload.postingId,
  });
}